import { render } from "./ChangePassword.vue?vue&type=template&id=3a498766&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=3a498766&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a498766"]])

export default __exports__